import React from 'react';
import { BulkDeleteButton } from 'react-admin';

const BulkActionDeleteButton = props => (
  <React.Fragment>
    <BulkDeleteButton {...props} undoable={false} />
  </React.Fragment>
);

export default BulkActionDeleteButton;
